<template>
  <c-navbar class="header" :title="title">
    <router-link to="/" slot="left">
      <img class="header-logo" src="../../assets/img/logo@full.png" />
    </router-link>
    <router-link to="/download" slot="right">
      <div class="header-text">APP下载</div>
    </router-link>
  </c-navbar>
</template>

<script>
  import CNavbar from 'base/navbar';

  export default {
    name: 'CHeader',
    components: {
      CNavbar,
    },
    props: {
      title: {
        type: String,
        default: '',
      },
    },
  };
</script>

<style lang="scss" scoped>
.header {
  &-logo {
    width: 100px;
  }

  &-text {
    padding: 0 8px;
    font-size: 12px;
    color: #fff;
    line-height: 20px;
    background-color: #fe563e;
    border-radius: 10px;
  }
}
</style>
